import React from 'react';
import * as styles from './SectionTitle.module.scss';
import { Button, Text, Heading } from 'components/core';

type Props = {
  title: string;
  showPreview?: boolean;
  pendoKey?: string;
  ariaLabel?: string;
  children?: React.ReactNode;
};

export const SectionTitle = ({
  title,
  showPreview = true,
  pendoKey,
  ariaLabel,
  children,
}: Props) => {
  return (
    <Heading
      type="h4"
      component="h3"
      variant="brand"
      className={styles.Title}
      id={title.toLowerCase().replace(/ /g, '_')}
    >
      <span>{title}</span>
      {children}
      {showPreview && (
        <Button
          size="sm"
          variant="outline"
          onClick={() => ''}
          data-pendo-key={pendoKey}
          aria-label={ariaLabel}
        >
          <Text size="sm">Example preview</Text>
        </Button>
      )}
    </Heading>
  );
};

export default SectionTitle;
